import React from 'react';

function Alertas(props) {
    return (
        <div className="card list-inline-item">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex flex-column align-items-center gap-1">
                        <h3 className="mb-2">ALERTAS</h3>
                        <span>0 Urgentes</span>
                    </div>
                    <div id="orderStatisticsChart"></div>
                </div>
                <ul className="p-0 m-0">
                    <li className="d-flex mb-4 pb-1">
                        <div className="avatar flex-shrink-0 me-3">
                            <span className="avatar-initial rounded bg-label-danger "><i className="bx bx-bell"></i></span>
                        </div>
                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                            <div className="me-2">
                                <h6 className="mb-0">Vencimiento resolución facturación</h6>
                                <small className="text-muted">Fecha vencimiento: 12 sept 2025</small>
                            </div>
                            <div className="user-progress">
                                <small className="fw-semibold">12 días</small>
                            </div>
                        </div>
                    </li>
                    <li className="d-flex mb-4 pb-1">
                        <div className="avatar flex-shrink-0 me-3">
                            <span className="avatar-initial rounded bg-label-success"><i className="bx bx-closet"></i></span>
                        </div>
                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                            <div className="me-2">
                                <h6 className="mb-0">Fashion</h6>
                                <small className="text-muted">T-shirt, Jeans, Shoes</small>
                            </div>
                            <div className="user-progress">
                                <small className="fw-semibold">23.8k</small>
                            </div>
                        </div>
                    </li>
                    <li className="d-flex mb-4 pb-1">
                        <div className="avatar flex-shrink-0 me-3">
                            <span className="avatar-initial rounded bg-label-info"><i className="bx bx-home-alt"></i></span>
                        </div>
                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                            <div className="me-2">
                                <h6 className="mb-0">Decor</h6>
                                <small className="text-muted">Fine Art, Dining</small>
                            </div>
                            <div className="user-progress">
                                <small className="fw-semibold">849k</small>
                            </div>
                        </div>
                    </li>
                    <li className="d-flex">
                        <div className="avatar flex-shrink-0 me-3">
                            <span className="avatar-initial rounded bg-label-secondary"><i className="bx bx-football"></i></span>
                        </div>
                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                            <div className="me-2">
                                <h6 className="mb-0">Sports</h6>
                                <small className="text-muted">Football, Cricket Kit</small>
                            </div>
                            <div className="user-progress">
                                <small className="fw-semibold">99</small>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Alertas;